import { ReservationSummary } from '@mews-commander/guest-profile';
import { lt, useToggle } from '@mews/framework';
import { Accordion } from '@optimus-web/core';
import { ItemLabel } from '../../common';
import { ReservationContent } from './ReservationContent';

interface ReservationItemProps extends ReservationSummary {
    lastItem: boolean;
}

export const ReservationItem = ({ id, lastItem, number, ...props }: ReservationItemProps) => {
    const [expanded, toggleExpanded] = useToggle();
    return (
        <Accordion
            key={id}
            expanded={expanded}
            onClick={toggleExpanded}
            headerPadding={{ top: '200', bottom: '200' }}
            title={<ItemLabel label={lt('Confirmation')} value={number ?? 0} />}
            withHeaderBorder={!lastItem || expanded}
            withBodyBorder={!lastItem}
            body={<ReservationContent {...props} />}
        />
    );
};
